/*
  Precio en moneda local según el país del visitante (por su IP).
  - País: /browsing_context_suggestions.json (de la propia tienda; la IP no sale de Shopify).
  - Tipo de cambio: window.MT_TASAS (assets/mt-tasas.js, regenerar con tools/actualizar-tasas.mjs).
  - Nada se envía a terceros; el país se recuerda solo en el navegador del visitante 24 h.
  - SOLO informativo: el cobro siempre es en USD en el checkout.
  Marca cualquier precio con: <div class="mt-price" data-usd="19.90">...</div>
*/
(function () {
  var MONEDA = { US:'USD', GB:'GBP', CA:'CAD', AU:'AUD', DE:'EUR', FR:'EUR', ES:'EUR', IT:'EUR', NL:'EUR',
    MX:'MXN', BR:'BRL', CL:'CLP', CO:'COP', AR:'ARS', SV:'USD', PE:'PEN', UY:'UYU' };
  var IDIOMA = { US:'en-US', GB:'en-GB', CA:'en-CA', AU:'en-AU', DE:'de-DE', FR:'fr-FR', ES:'es-ES', IT:'it-IT',
    NL:'nl-NL', MX:'es-MX', BR:'pt-BR', CL:'es-CL', CO:'es-CO', AR:'es-AR', SV:'es-SV', PE:'es-PE', UY:'es-UY' };
  var TIEMPO_MAX = 2500; // ms: si algo tarda más, mostramos USD

  function leer(k) { try { var v = JSON.parse(localStorage.getItem(k)); return v && v.exp > Date.now() ? v.val : null; } catch (e) { return null; } }
  function guardar(k, val, horas) { try { localStorage.setItem(k, JSON.stringify({ val: val, exp: Date.now() + horas * 36e5 })); } catch (e) {} }
  function conTiempo(p) { return Promise.race([p, new Promise(function (_, no) { setTimeout(no, TIEMPO_MAX); })]); }

  function pais() {
    var c = leer('mt-pais'); if (c) return Promise.resolve(c);
    return conTiempo(fetch('/browsing_context_suggestions.json').then(function (r) { return r.json(); }))
      .then(function (j) { var cc = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle; if (cc) guardar('mt-pais', cc, 24); return cc; });
  }
  // Tipos de cambio del día desde el CDN de Shopify (currencies.js: valor de 1 unidad en USD).
  // Si falla, se usa la copia local assets/mt-tasas.js. Caché 6 h en el navegador.
  function tasas() {
    var t = leer('mt-tasas-shopify'); if (t) return Promise.resolve(t);
    return conTiempo(fetch('https://cdn.shopify.com/s/javascripts/currencies.js').then(function (r) { return r.text(); }))
      .then(function (txt) {
        var bloque = (txt.match(/rates:\s*\{([^}]*)\}/) || [])[1], out = {}, m, re = /([A-Z]{3}):([0-9.e+-]+)/g;
        while (bloque && (m = re.exec(bloque))) { var v = parseFloat(m[2]); if (v > 0) out[m[1]] = 1 / v; }
        if (!out.CLP) throw new Error('sin tasas');
        guardar('mt-tasas-shopify', out, 6);
        return out;
      })
      .catch(function () { return window.MT_TASAS || null; });
  }
  // Plazos mostrados = plazo de CJ con ~40% de margen (CJ 14 → 20), máximo 60 — ver docs/01-producto-y-costes.md
  var PLAZO = { US:'8–16', GB:'8–13', CA:'10–21', AU:'11–24', DE:'15–29', FR:'15–29', ES:'15–29', IT:'15–29', NL:'15–29',
    MX:'17–23', BR:'11–17', CL:'12–19', CO:'15–60', AR:'18–60', SV:'15–60' };
  var NOMBRE = { US:'Estados Unidos', GB:'Reino Unido', CA:'Canadá', AU:'Australia', DE:'Alemania', FR:'Francia', ES:'España',
    IT:'Italia', NL:'Países Bajos', MX:'México', BR:'Brasil', CL:'Chile', CO:'Colombia', AR:'Argentina', SV:'El Salvador' };

  function fmt(n, moneda, idioma) {
    // min y max juntos: Safari antiguo lanza RangeError si max < min por defecto de la moneda
    var dec = n >= 1000 ? 0 : 2;
    try {
      return new Intl.NumberFormat(idioma, { style: 'currency', currency: moneda, minimumFractionDigits: dec, maximumFractionDigits: dec }).format(n);
    } catch (e) {
      return moneda + ' ' + n.toFixed(dec);
    }
  }
  // Cifra atractiva más cercana (mismo criterio que charmNear en tools/precios-atractivos.mjs)
  function atractivo(n) {
    if (n < 1000) return Math.round(n) - 0.01;
    return Math.round((n + 10) / 1000) * 1000 - 10;
  }
  function pintarEntrega(cc) {
    var el = document.querySelector('[data-mt-plazo]');
    if (!el || !PLAZO[cc]) return;
    el.textContent = PLAZO[cc] + ' días hábiles a ' + NOMBRE[cc];
  }

  function pintar(cc, rates) {
    var moneda = MONEDA[cc], idioma = IDIOMA[cc] || 'es';
    Array.prototype.forEach.call(document.querySelectorAll('.mt-price[data-usd]'), function (el) {
      var usd = parseFloat(el.getAttribute('data-usd'));
      var main = el.querySelector('.mt-price__main'), nota = el.querySelector('.mt-price__note');
      var usdTxt = fmt(usd, 'USD', 'en-US') + ' USD';
      if (moneda && moneda !== 'USD' && rates && rates[moneda]) {
        // Precio atractivo: el USD de cada mercado se fija (tools/precios-atractivos.mjs) para que su
        // conversión caiga justo en una cifra x,99 / x.990; aquí se redondea a la más cercana.
        var local = fmt(atractivo(usd * rates[moneda]), moneda, idioma);
        if (local.indexOf('$') > -1) local += ' ' + moneda; // "$" es ambiguo (CLP, MXN, COP…): añadimos el código
        main.textContent = '≈ ' + local;
        if (nota) nota.textContent = el.getAttribute('data-nota').replace('[USD]', usdTxt);
      } else {
        main.textContent = usdTxt;
        if (nota) nota.textContent = el.getAttribute('data-nota-usd') || '';
      }
      el.setAttribute('data-estado', 'listo');
    });
  }

  function iniciar() {
    if (!document.querySelector('.mt-price[data-usd]')) return;
    pais().then(pintarEntrega, function () {});
    Promise.all([pais(), tasas()]).then(function (r) { pintar(r[0], r[1]); }, function () { pintar(null, null); });
  }
  window.mtPrecioLocal = iniciar; // la ficha lo vuelve a llamar al cambiar de variante
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();

  // Aparición al hacer scroll
  document.addEventListener('DOMContentLoaded', function () {
    var els = document.querySelectorAll('.mt-reveal');
    var each = function (fn) { Array.prototype.forEach.call(els, fn); };
    if (!('IntersectionObserver' in window)) { each(function (e) { e.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } }); }, { threshold: .15 });
    each(function (e) { io.observe(e); });
  });
})();
